// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-version-revert-modal .form-version-revert-modal-description{display:flex;flex-direction:column;row-gap:10px}.form-version-revert-modal .form-version-revert-modal-description .form-name{display:inline;font-weight:bold}", ""]);
// Exports
module.exports = exports;
